import Instructions from './Instructions.js';

export default Instructions;



// WEBPACK FOOTER //
// ./src/components/FormElements/Instructions/index.js